import React from "react";
import { DEFAULT_RANGE_TYPE } from "../../../Utils/dateRange";

export const OPTIONS = [
  { key: "today", label: "Today" },
  { key: "lifetime", label: "Lifetime" },
  { key: "1w", label: "1 Week" },
  { key: "30d", label: "30 Days" },
  { key: "90d", label: "90 Days" },
  { key: "custom", label: "Custom" }
];

function DateRangeFilter({ value = DEFAULT_RANGE_TYPE, onRangeChange }) {
  const handleSelect = (e) => {
    if (onRangeChange) onRangeChange({ type: e.target.value });
  };

  return (
    <select
      className="dr-select"
      value={value}
      onChange={handleSelect}
      data-cy="dr-select"
    >
      {OPTIONS.map((opt) => (
        <option key={opt.key} value={opt.key}>{opt.label}</option>
      ))}
    </select>
  );
}

export default DateRangeFilter;
